export default "__VITE_ASSET__CQBaBwoV__"